import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";

export default function AthleteProfileTab({
  isAdmin,
  profileData,
  handleChange,
  handleClose,
  handleSubmit,
  positions,
  states,
}) {
  return (
    <form onSubmit={handleSubmit} className="w-full text-sm">
      <div className="flex flex-wrap -mx-6 px-2 overflow-y-auto overflow-x-hidden h-[488px]">
        <div className="w-full md:w-1/2 px-3 pt-0">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="username"
          >
            Username/Email
          </label>
          <input
            name="username"
            className={`appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900 ${
              !isAdmin ? "bg-gray-100 cursor-not-allowed" : ""
            }`}
            id="username"
            type="email"
            value={profileData.username || profileData.email || ""}
            onChange={handleChange}
            readOnly={!isAdmin}
            disabled={!isAdmin}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 pt-0">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="firstName"
          >
            First Name
          </label>
          <input
            name="firstName"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="firstName"
            type="text"
            value={profileData.firstName ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 pt-0 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="lastName"
          >
            Last Name
          </label>
          <input
            name="lastName"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="lastName"
            type="text"
            value={profileData.lastName ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="primaryPosition"
          >
            Primary Position
          </label>
          <div className="relative mb-2">
            <select
              name="primaryPosition"
              className="form-select bg-no-repeat block appearance-none w-full border border-gray-300 text-gray-900 p-2.5 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="primaryPosition"
              value={profileData.primaryPosition || ""}
              onChange={handleChange}
            >
              {positions.map((position) => (
                <option key={position} value={position}>
                  {position}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="w-full md:w-2/4 px-3 mb-6 md:mb-0">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="secondaryPosition"
          >
            Secondary Position
          </label>
          <div className="relative">
            <select
              name="secondaryPosition"
              className="form-select bg-no-repeat block appearance-none w-full border border-gray-300 text-gray-900 p-2.5 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="secondaryPosition"
              value={profileData.secondaryPosition || ""}
              onChange={handleChange}
            >
              {positions.map((position) => (
                <option key={position} value={position}>
                  {position}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 pt-0">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="highSchool"
          >
            High School
          </label>
          <input
            name="highSchool"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="highSchool"
            type="text"
            value={profileData.highSchool ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 pt-0">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="footballClub"
          >
            Football Club
          </label>
          <input
            name="footballClub"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="footballClub"
            type="text"
            value={profileData.footballClub ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 pt-0 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="expectedYearOfGraduation"
          >
            Graduation year
          </label>
          <input
            name="expectedYearOfGraduation"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="expectedYearOfGraduation"
            type="text"
            value={profileData.expectedYearOfGraduation ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 pt-0 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="city"
          >
            City
          </label>
          <input
            name="city"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="city"
            type="text"
            value={profileData.city ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-2/4 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="state"
          >
            State
          </label>
          <div className="relative">
            <select
              name="state"
              className="form-select bg-no-repeat block appearance-none w-full border border-gray-300 text-gray-900 p-2.5 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="state"
              value={profileData.state ?? ""}
              onChange={handleChange}
            >
              {states.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="gpa"
          >
            GPA
          </label>
          <input
            name="gpa"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="gpa"
            type="text"
            value={profileData.gpa ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 md:mb-0">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="universityOfInterest"
          >
            University of Interest
          </label>
          <input
            name="universityOfInterest"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="universityOfInterest"
            type="text"
            value={profileData.universityOfInterest ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="academicDegreeOfInterest"
          >
            Academic Degree of Interest
          </label>
          <input
            name="academicDegreeOfInterest"
            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
            id="academicDegreeOfInterest"
            type="text"
            value={profileData.academicDegreeOfInterest ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="instagram"
          >
            Instagram
          </label>
          <div className="relative">
            <FontAwesomeIcon
              icon={faInstagram}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            />
            <input
              name="instagram"
              className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pl-10 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
              id="instagram"
              type="text"
              value={profileData.instagram ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="twitter"
          >
            Twitter
          </label>
          <div className="relative">
            <FontAwesomeIcon
              icon={faXTwitter}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            />
            <input
              name="twitter"
              className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pl-10 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
              id="twitter"
              type="text"
              value={profileData.twitter ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="athleteEmail"
          >
            Athlete Email
          </label>
          <div className="relative">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            />
            <input
              name="athleteEmail"
              className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pl-10 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
              id="athleteEmail"
              type="email"
              value={profileData.athleteEmail ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="parentEmail"
          >
            Parent Email
          </label>
          <div className="relative">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            />
            <input
              name="parentEmail"
              className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pl-10 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
              id="parentEmail"
              type="email"
              value={profileData.parentEmail ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="athletePhone"
          >
            Athlete Phone
          </label>
          <div className="relative">
            <FontAwesomeIcon
              icon={faPhone}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            />
            <input
              name="athletePhone"
              className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pl-10 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
              id="athletePhone"
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              value={profileData.athletePhone ?? ""}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, "");
                handleChange({
                  target: {
                    name: e.target.name,
                    value: numericValue,
                  },
                });
              }}
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 px-3 mb-1">
          <label
            className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            htmlFor="parentPhone"
          >
            Parent Phone
          </label>
          <div className="relative">
            <FontAwesomeIcon
              icon={faPhone}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            />
            <input
              name="parentPhone"
              className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pl-10 mb-2 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
              id="parentPhone"
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              value={profileData.parentPhone ?? ""}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, "");
                handleChange({
                  target: {
                    name: e.target.name,
                    value: numericValue,
                  },
                });
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          type="button"
          onClick={handleClose}
          className="px-4 py-2 text-gray-600 border rounded-md hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
        >
          Update
        </button>
      </div>
    </form>
  );
}
